import FItemDate from '../FItem/Date';
import component from './component.vue';

export default class FDate extends FItemDate {
  static mask = 'dd.MM.yyyy';

  __component = component;

  constructor(props) {
    super(props);
    this.picker = props.picker || false;
  }

  get data() {
    return {
      [this.__name]: this.toString(),
    };
  }

  get options() {
    return {
      mask: Date,
      min: this.min,
      max: this.max,
      format(date) {
        if (!date) {
          return '';
        }
        const day = String(date.getDate())
          .padStart(2, '0');
        const month = String(date.getMonth() + 1)
          .padStart(2, '0');
        const year = date.getFullYear();
        return [day, month, year].join('.');
      },
    };
  }
}
